import React from 'react';
import './Music.css';
import albumCover1 from '../images/Hotelcalifornia.jpg';
import albumCover2 from '../images/ac-dc.jpg';
import albumCover3 from '../images/guns-n-roses.webp';
import likeHim from '../images/likeHim.jpg';
import hereWithMe from '../images/hereWithMe.jpg';
import iLoveKanye from '../images/iLoveKanye.jpg';
import endOfTheBeginning from '../images/endOfTheBeginning.jpg';
import youDontMessAroundWithJim from '../images/youDontMessAroundWithJim.jpg';
import five05 from '../images/505.jpg';
import iWonder from '../images/iWonder.jpg';
import borderline from '../images/borderline.jpg';
import theLessIKnowTheBetter from '../images/theLessIKnowTheBetter.jpg';

const spotifyPlaylists = [
  {
    id: '3KUiivuqn2rq8mjXgAUMxc',
    label: 'Spotify Playlist 1',
  },
  {
    id: '7lpyX9hbhD33IJu5R1fLoZ',
    label: 'Spotify Playlist 2',
  },
  {
    id: '3KpQHlzSrI6Q5d3eIbwvfd',
    label: 'Spotify Playlist 3',
  },
  {
    id: '1tZNqXOnzS1ceUHS39FsRh',
    label: 'Spotify Playlist 4',
  },
  {
    id: '0hp9D2rEreHD8WWBKmvTk8',
    label: 'Spotify Playlist 5',
  },
  {
    id: '4lhhv2K9TwB8zDiCc1yXmk',
    label: 'Spotify Playlist 6',
  },
];

const favoriteAlbums = [
  { title: 'I Love Kanye', artist: 'Kanye West', imgSrc: iLoveKanye },
  { title: 'End of the Beginning', artist: 'Djo', imgSrc: endOfTheBeginning },
  { title: "You Don't Mess Around with Jim", artist: 'Jim Croce', imgSrc: youDontMessAroundWithJim },
  { title: '505', artist: 'Arctic Monkeys', imgSrc: five05 },
  { title: 'I Wonder', artist: 'Kanye West', imgSrc: iWonder },
  { title: 'Borderline', artist: 'Tame Impala', imgSrc: borderline },
  { title: 'The Less I Know The Better', artist: 'Tame Impala', imgSrc: theLessIKnowTheBetter },
  { title: 'Hotel California', artist: 'The Eagles', imgSrc: albumCover1 },
  { title: 'Back in Black', artist: 'AC/DC', imgSrc: albumCover2 },
  { title: "Appetite for Destruction", artist: "Guns N' Roses", imgSrc: albumCover3 },
  { title: 'Like Him', artist: 'Tyler, The Creator', imgSrc: likeHim },
  { title: 'Here With Me', artist: 'd4vd', imgSrc: hereWithMe },
];

const Music: React.FC = () => {
  return (
    <div className="music-page">
      <div className="quote">
        <p>"Music isn't just art, it's a way of life."</p>
      </div>

      <div className="spotify-section">
        <h3>My Spotify Playlists</h3>
        <div className="playlist-grid">
          {spotifyPlaylists.map((playlist, index) => (
            <div
              key={playlist.id}
              className="playlist-card"
              style={{ animationDelay: `${index * 0.12}s` }}
            >
              <div className="playlist-embed-wrap">
                <iframe
                  title={playlist.label}
                  src={`https://open.spotify.com/embed/playlist/${playlist.id}?utm_source=generator`}
                  width="100%"
                  height="352"
                  frameBorder="0"
                  allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                  loading="lazy"
                />
              </div>
              <a
                className="playlist-link"
                href={`https://open.spotify.com/playlist/${playlist.id}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                Open in Spotify
              </a>
            </div>
          ))}
        </div>
      </div>

      <div className="albums-section">
        <h3>Favorite songs</h3>
        <div className="albums">
          {favoriteAlbums.map((album, index) => (
            <div key={index} className="album-card" style={{ animationDelay: `${index * 0.3}s` }}>
              <img src={album.imgSrc} alt={album.title} className="album-image" />
              <div className="album-details">
                <h4>{album.title}</h4>
                <p>by {album.artist}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Music;
